var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.isLoad,"class-name":"loading"}},[_c('van-loading',{attrs:{"color":"#1989fa"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }